@if (formats$ | async; as formats) {
    @switch (formats.status) {
        @case ("loading") {
            <span class="sh-hierarchy-table__skeleton" aria-hidden="true"></span>
        }
        @case ("ready") {
            @if (formats.badges.length) {
                <ul class="sh-tag-list digihaven-stuk-formats">
                    @for (badge of formats.badges; track badge.label) {
                        <!-- The native title as an interim: this codebase has no tooltip component yet. -->
                        <li class="sh-tag--readonly -sh-small sh-tag-list__item" [attr.title]="badge.roles.length ? badge.roles.join(', ') : null">
                            @if (badge.isAccess && formats.previewRecordId; as previewRecordId) {
                                <digihaven-format-preview-link [label]="badge.label" [recordId]="previewRecordId" [roles]="badge.roles" />
                            } @else {
                                <span class="sh-tag__label">{{ badge.label }}</span>
                            }
                        </li>
                    }
                </ul>
            } @else {
                {{ defaultValue$ | async }}
            }
        }
    }
    <!-- `unknown` renders nothing: a truncated or failed lookup would otherwise show a stuk's formats short. -->
}
